import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Plan } from 'app/models/plan';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { PlanService } from 'app/services/plan/plan.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import * as S3 from 'aws-sdk/clients/s3';

@Component({
  selector: 'app-ajouter-categorie',
  templateUrl: './ajouter-categorie.component.html',
  styleUrls: ['./ajouter-categorie.component.scss']
})
export class AjouterCategorieComponent implements OnInit {

  selectedFiles: FileList;
  fileNames: any[] = [];
  photourl!: string;
  allAttch: any[] = [];
  public image!: string;
  public agenciesProduit: any;
  public piece: any;
  public idPiece: any;
  
  // Initialize as an empty object of type Plan
  public plans: Plan = {
    etage: '',
    nbBeds: 0,
    nbBath: 0,
    sqft: 0,
    photosPlan: []
  };

  constructor(
    private produitService: ProduitsService,
    private activatedRoute: ActivatedRoute,
    private planService: PlanService,
    private pieceService: PiecesService,
    private router: Router
  ) {}

  public getRandomString(length: number): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  uploadimg2() {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles[i];
      this.uploadFileimg2(file);
    }
  }

  selectFileimg(e: any) {
    this.selectedFiles = e.target.files;
    this.uploadimg2();
  }

  async uploadFileimg2(file: any) {
    this.fileNames.push(file.name);
    const contentType = file.type;
    const bucket = new S3({
      accessKeyId: "0",
      secretAccessKey: "0",
      region: "eu-west-3",
    });
    const params = {
      Bucket: "0-0",
      Key: this.getRandomString(5) + file.name,
      Body: file,
      ACL: "public-read",
      ContentType: contentType,
    };

    let planImg: any;
    bucket.upload(params, async function (err: any, data: any) {
      if (err) console.error(err);
      console.log(data.Location);
      planImg = data.Location;
    });

    // Wait for upload to complete (better to use Promise)
    setTimeout(() => {
      console.log(planImg);
      this.allAttch.push(planImg);
      console.log(this.allAttch);
      localStorage.setItem('planImg', JSON.stringify(this.allAttch));
    }, 2000);

    bucket.upload(params).on('httpUploadProgress', function (evt: any) {
      let progress = Math.round(100 * evt.loaded / evt.total);
    }).send(function (err: any, data: any) {
      if (err) {
        console.log('There was an error uploading your file: ', err);
      }
      if (data) {
        console.log('Successfully uploaded file.', data);
      }
    });
  }

  getData() {
    this.produitService.getListProduit().subscribe((data) => {
      this.agenciesProduit = data;
    });

    this.idPiece = this.activatedRoute.snapshot.paramMap.get('id');

    this.pieceService.getPiece(this.idPiece).subscribe(data => {
      console.log(data);
      this.piece = data;
    });
  }

  ngOnInit() {
    this.produitService.refreshNedeed.subscribe(() => this.getData());
    this.getData();
  }

  onSubmit() {
    // Retrieve stored images from localStorage
    const storedImages = localStorage.getItem("planImg");
    const photosArray = storedImages ? JSON.parse(storedImages) : [];

    const planData: Plan = {
      etage: this.plans.etage,
      nbBeds: this.plans.nbBeds,
      nbBath: this.plans.nbBath,
      sqft: this.plans.sqft,
      photosPlan: photosArray,
      description: this.plans.description,
      prix: this.plans.prix,
      videoUrl: this.plans.videoUrl
    };

    this.planService.createPlan(this.idPiece, planData).subscribe(() => {
      localStorage.removeItem("planImg"); // clean up
      this.router.navigate(['listePiece']);
    });
  }
}